"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var FooterLinks = /** @class */ (function (_super) {
    __extends(FooterLinks, _super);
    function FooterLinks(props) {
        var _this = _super.call(this, props) || this;
        _this.buildItems = function (links, style) {
            return links
                ? links.map(function (link, i) {
                    return style == "small" ? (React.createElement("a", { key: i, href: link.url, title: link.title, className: "text-xs mobile:w-1/3 md:ml-3-2 font-body text-arctic hover:text-grey-mid underline-none hover:underline transition-fast capitalize" }, link.title)) : (React.createElement("li", { key: i, className: "block w-1/" + links.length + " md:border-0 md:mb-0 md:pb-0  border-b border-native w-full" },
                        React.createElement("a", { title: link.title, className: "block leading-normal mb-2 md:pt-0 pt-2-4 font-body text-arctic opacity-90 hover:opacity-100 no-underline whitespace-no-wrap transition-fast text-sm tracking-wide2x font-extrabold", onClick: function () { return _this.dropdown(link.title); } },
                            link.title,
                            React.createElement("span", { className: "float-right text-arctic md:hidden " + (_this.state.activeDropdown && _this.state.activeDropdown == link.title ? "hidden" : "inline-block") },
                                React.createElement(Snippets.Svg, { name: "plus", width: 14, className: "ml-0-2 text-arctic inline-block align-middle" })),
                            React.createElement("span", { className: "float-right text-arctic md:hidden " + (_this.state.activeDropdown && _this.state.activeDropdown == link.title ? "inline-block" : "hidden") },
                                React.createElement(Snippets.Svg, { name: "minus", width: 14, className: "ml-0-2 text-arctic inline-block align-middle" }))),
                        React.createElement("ul", { className: "list-reset md:max-h-none overflow-hidden transition-slow " + (_this.state.activeDropdown && _this.state.activeDropdown == link.title ? "max-h-85" : "max-h-0") }, link.links && link.links.length > 0 ? _this.buildLinks(link.links) : null)));
                })
                : [];
        };
        _this.buildLinks = function (links) {
            return links
                ? links.map(function (link, i) { return (React.createElement("li", { key: i, className: "mb-1" },
                    React.createElement("a", { href: link.url, title: link.title, className: "font-body text-base font-normal border-b border-transparent text-arctic hover:border-arctic transition-fast capitalize leading-normal" }, link.title))); })
                : [];
        };
        _this.state = {
            activeDropdown: null
        };
        return _this;
    }
    FooterLinks.prototype.dropdown = function (link) {
        var newDropdown = this.state.activeDropdown === link ? null : link;
        this.setState({
            activeDropdown: newDropdown
        });
    };
    FooterLinks.prototype.render = function () {
        var _a = this.props, linklist = _a.linklist, style = _a.style;
        return linklist && linklist.links && linklist.links.length ? (style == "small" ? (this.buildItems(linklist.links, style)) : (React.createElement("nav", { className: "md:flex-1 w-full" },
            React.createElement("ul", { className: "w-full list-reset flex flex-col lg:flex-row justify-center" }, this.buildItems(linklist.links, style))))) : null;
    };
    return FooterLinks;
}(React.Component));
exports.FooterLinks = FooterLinks;
